import React from 'react';
import { useSSRExperiment } from '../../context';

export function useGetPromotedLabelPosition(component: React.ReactNode): {
    promotedLabelAsHeader?: React.ReactNode;
    promotedLabelAsSubtitle?: React.ReactNode;
    promotedLabelAsBottom?: React.ReactNode;
} {
    const position = useSSRExperiment(
        SEARCH_PROMOTED_LABEL_POSITION_EXPERIMENT.name,
        SEARCH_PROMOTED_LABEL_POSITION_EXPERIMENT.paramName,
        SEARCH_PROMOTED_LABEL_POSITION_EXPERIMENT.defaultValue,
    );

    return {
        promotedLabelAsHeader:
            position === PromotedLabelPosition.top ? component : undefined,
        promotedLabelAsSubtitle:
            position === PromotedLabelPosition.subtitle ? component : undefined,
        promotedLabelAsBottom:
            position === PromotedLabelPosition.bottom ? component : undefined,
    };
}

export enum PromotedLabelPosition {
    top = 'top',
    subtitle = 'subtitle',
    bottom = 'bottom',
}

export const SEARCH_PROMOTED_LABEL_POSITION_EXPERIMENT = {
    name: 'search_promoted_label_position',
    paramName: 'position',
    defaultValue: PromotedLabelPosition.top,
};
